export default "__VITE_ASSET__2b48e3e2__"